import React, { useEffect, useState } from "react";
import { APIURL } from "./config";
import axios from "axios";

const AuthGuard = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  useEffect(() => {
    const checkAuth = async () => {
      try {
        // Check if the user is authenticated via the session (Laravel's default web authentication)
        axios
          .get(`${APIURL}/sanctum/csrf-cookie`, {
            withCredentials: true,
          })
          .then(() => {
            // Now make the authenticated request
            axios
              .post(
                `${APIURL}/api/check-auth`,
                {},
                {
                  withCredentials: true,
                }
              )
              .then((response) => {
                // console.log(response, "response");
                if(response.data.auth){
                    setIsAuthenticated(true);
                }
              })
              .catch((error) => {
                console.error("Error during check-auth request:", error);
                setIsAuthenticated(null);
                window.location.href = `${APIURL}/login`; // Redirect to login page on error
              });
          })
          .catch((error) => {
            console.error("Error during CSRF cookie request:", error);
            setIsAuthenticated(null);
            window.location.href = `${APIURL}/login`; // Redirect to login page on error
          });
      } catch (error) {
        console.error("Error checking auth:", error);
        setIsAuthenticated(null);
        window.location.href = `${APIURL}/login`; // Redirect to login page on error
      }
    };

    checkAuth();
  }, []);

  if (isAuthenticated === null) {
    return (
      <div className="main-area">
        <div id="cover-spin"></div>
      </div>
    ); // Show loading while checking auth
  }

  return isAuthenticated ? children : null;
};

export default AuthGuard;
